// Copyright 2016 Sorama B.V.

export class Size {
    width: number;
    height: number;
}
